'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactPdf = require('react-pdf');
var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
reactPdf.pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${reactPdf.pdfjs.version}/pdf.worker.min.js`;
const UnstyledPdfRender = ({ attachment , id , onLoadSuccess , page , pageProps , ...otherProps })=>{
    const [pages, setPages] = React.useState(null);
    const [hasError, setHasError] = React.useState(false);
    if (!attachment) return null;
    const { cdn_url , height , url , width  } = attachment;
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, otherProps, {
        id: id,
        style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }), /*#__PURE__*/ React__default.default.createElement(reactPdf.Document, {
        file: hasError ? url : cdn_url,
        onLoadSuccess: ({ numPages  })=>{
            setPages(numPages);
            onLoadSuccess && onLoadSuccess(numPages);
        },
        onLoadError: (error)=>{
            console.error(error);
            setHasError(true);
        }
    }, pages ? /*#__PURE__*/ React__default.default.createElement(PageWrapper, {
        className: pageProps?.className
    }, /*#__PURE__*/ React__default.default.createElement(reactPdf.Page, {
        height: height,
        pageNumber: page,
        renderAnnotationLayer: false,
        renderTextLayer: false,
        width: width
    })) : null));
};
const StyledPdfPreview = styled__default.default(UnstyledPdfRender)`
  .react-pdf__Page__canvas {
    margin: auto;
    max-height: 100%;
    max-width: 100% !important;
    object-fit: contain;
  }

  .react-pdf__Document {
    height: 100%;
  }

  .react-pdf__Page {
    height: 100%;
    background: ${(props)=>props.background} !important;
    display: flex;
  }
`;
const PageWrapper = styled__default.default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`;
const StandardPdfPreview = (props)=>{
    return /*#__PURE__*/ React__default.default.createElement(StyledPdfPreview, _extends({}, props));
};

exports.StandardPdfPreview = StandardPdfPreview;
exports.UnstyledPdfRender = UnstyledPdfRender;
//# sourceMappingURL=standard-pdf-preview.js.map
